module.exports = __webpack_public_path__ + "img/home_icon_fuwu_normal.648d0f7b.png";